import Blazy from 'blazy'

export function init() {
  loadMedia()
}

export function lazyloadNewMedia() {
  loadMedia()
}

export function loadMedia(selector = '.lazy') {
  new Blazy({
    selector,
    successClass: ' ',
    errorClass: 'error',
    success: (el) => {
      const parent = el.parentElement
      parent.classList.add('no-spinner')
      setTimeout(() => el.classList.add('loaded'), 10)
    },
  })
}

export function revalidate() {
  // bLazy && bLazy.revalidate();
  loadMedia('[data-src]')
}
